import { firebase } from "../firebase-config";
import { BaseUrl, COLLECTIONS, STRIPE_SECRETE,DOMAINURL } from "../config";
import { getAuth } from 'firebase/auth';
import { addDoc, arrayRemove, arrayUnion, collection, doc, getDoc, getDocs, limit, onSnapshot, orderBy, query, setDoc, Timestamp, updateDoc, where } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { datetimest, getuniqueId } from "../helpers";
import axiosInstance from "../axios";
import Stripe from "stripe";
import { getLoginToken } from "../storage";
const stripe = new Stripe(STRIPE_SECRETE);
const auth = getAuth();


const defaultHeaders = {
  "Content-Type": "application/json",
  withCredentials: true,
};


export async function SaveSupportTicket(formData, onSuccess, onError) {
  try {
    const resultNumberQuery = query(
      collection(firebase, COLLECTIONS.SUPPORT),
      orderBy('ticketNumber', 'desc'),
      limit(1)
    );
    const resultNumber = await getDocs(resultNumberQuery);

    let newTicketNumber = 1001;

    resultNumber.forEach((doc) => {
      const apptData = doc.data();
      newTicketNumber = apptData.ticketNumber + 1;
    });

    const currentUser = auth.currentUser;
    const currentUserId = currentUser ? currentUser.uid : null;

    const newSupportData = {
      ...formData,
      createdBy: currentUserId,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
      archive: false,
      ticketNumber: newTicketNumber,
    };

    const docRef = await addDoc(collection(firebase, COLLECTIONS.SUPPORT), newSupportData);

    const responseItem = { ...newSupportData, id: docRef.id };
    onSuccess && onSuccess({ status: true, data: responseItem });
    return { status: true, data: responseItem };

  } catch (error) {
    console.log(`ERROR: ${error.message || error}`);
    onError && onError({ status: false, error: error.message || error });
  }
}


export async function uploadAttachment (companyId, file) {
  const storage = getStorage();
  const storageRef = ref(storage, `${companyId}/support/${file.name}`);
  await uploadBytes(storageRef, file);
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
};


// export async function getSupportTickets(companyId) {
//   try {
//     let supportQuery;

//     if (companyId) {
//       supportQuery = query(
//         collection(firebase, COLLECTIONS.SUPPORT),
//         where("companyId", "==", companyId)
//       );
//     } else {
//       supportQuery = query(collection(firebase, COLLECTIONS.SUPPORT));
//     }

//     const querySnapshot = await getDocs(supportQuery);

//     const supports = querySnapshot.docs.map(doc => ({
//       id: doc.id,
//       ...doc.data(),
//     }));

//     return { status: true, data: supports };
//   } catch (error) {
//     return { status: false, error: error.message };
//   }
// }

export function getSupportTickets(companyId, onSuccess, onError) {
  try {
    let supportQuery;

    if (companyId) {
      supportQuery = query(
        collection(firebase, COLLECTIONS.SUPPORT),
        where("companyId", "==", companyId)
      );
    } else {
      supportQuery = query(collection(firebase, COLLECTIONS.SUPPORT));
    }

    const unsubscribe = onSnapshot(
      supportQuery,
      (querySnapshot) => {
        const supports = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        onSuccess && onSuccess(supports);
      },
      (error) => {
        console.error("subscribeSupportTickets error:", error);
        onError && onError(error);
      }
    );

    return unsubscribe;
  } catch (error) {
    onError && onError(error);
    return () => {};
  }
}

export async function getSupportTicketDetails(id, callback) {
  try {
    const docRef = doc(firebase, COLLECTIONS.SUPPORT, id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const result = { status: true, data: { id: docSnap.id, ...docSnap.data() }};
      callback && callback(result);
      return result;
    } else {
      const result = { status: false, error: "No document found with this ID." };
      callback && callback(result);
      return result;
    }
  } catch (error) {
    const result = { status: false, error: error.message };
    callback && callback(result);
    return result;
  }
}

export async function SaveSupportResponse(id, formData, details, userData, companyName, onSuccess, onError) {
  try {
    const docRef = doc(firebase, COLLECTIONS.SUPPORT, id);
    const docSnap = await getDoc(docRef);

    const currentUser = auth.currentUser;
    const currentUserId = currentUser ? currentUser.uid : null;

    if (!docSnap.exists()) {
      return { status: false, error: "Support ticket not found." };
    }

    const existingData = docSnap.data();
    const newid = getuniqueId("res");

    const sendFormData = {
      ...(existingData.responses || {}),
      [newid]: {
        ...formData,
        respondBy: details,
        respondOn: datetimest(),
      },
    };

    const updatedData = {
      ...existingData,
      responses: sendFormData,
      readUser: [currentUserId],
      updatedAt: Timestamp.now(),
    };

    await updateDoc(docRef, updatedData);

    const responseItem = { id: docRef.id, ...updatedData };
    onSuccess && onSuccess({ status: true, data: responseItem });
    const emailPromise = userData?.email
      ? axiosInstance.post(`${BaseUrl}sendEmailData`, {
          email: userData.email,
          subject: `ProTeams - (${companyName}) Support Request: ${existingData?.ticketNumber} (${details?.name})`,
          contenttxt: `
          <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #eee; border-radius: 10px;">
                        
          <div style="text-align: center; margin-bottom: 20px;">
          <img src="https://${DOMAINURL}/csmGrayTextLogin.png" alt="ProTeams Logo" style="height: 60px;" />
          </div>
          <p>Hello ${userData?.name || ""},</p>
            <p><strong>${formData?.response || "Please check your support dashboard for more information."}</strong></p>
          <p style="font-size: 14px; color: #666;">
            If you have any questions about using the CMS or need assistance getting started, please don't hesitate to reach out to our support team.
          </p>
            <hr style="margin: 30px 0;">
            <div class="footer" style="text-align: center; color: #666; font-size: 13px;">
                <p>For assistance, feel free to <a href="mailto:support@proteams.io" style="color: #078037;">contact support</a>.</p>
              <p>&copy; ${new Date().getFullYear()} ProTeams All rights reserved.</p>
              </div>
            </div>`,
          support: true,
        })
      : Promise.resolve();

    const pushPromise = userData?.id
      ? axiosInstance.post(`${BaseUrl}sendPushNotifications`, {
          userIds: userData.id,
          title: "ProTeams - Support Response",
          textMessage: formData?.response,
          extData: { type: "support" },
        })
      : Promise.resolve();

    Promise.allSettled([emailPromise, pushPromise]).then((results) => {
      results.forEach((res, idx) => {
        if (res.status === "rejected") {
          const action = idx === 0 ? "Email" : "Push notification";
          console.error(`Failed to send ${action}:`, res.reason?.message || res.reason);
        }
      });
    });

    return { status: true, data: responseItem };
  } catch (error) {
    console.log(`ERROR: ${error.message || error}`);
    onError && onError({ status: false, error: error.message || error });
    return { status: false, error: error.message || error };
  }
}

export async function updateReadStatus(id, onSuccess, onError) {
  const currentUser = auth.currentUser;
  const currentUserId = currentUser ? currentUser.uid : null;
  try {
    const colRef = collection(firebase, COLLECTIONS.SUPPORT);
    const docRef = doc(colRef, id);

    await setDoc(docRef, { readUser: arrayUnion(currentUserId), updatedAt: Timestamp.now()}, { merge: true });

    onSuccess && onSuccess({ status: true });
  } catch (error) {
    console.error("Error updating read status:", error);
    onError && onError({ status: false, message: error.message });
  }
}

export async function updateSupportStatus(id, status, onSuccess, onError) {
  try {
    const currentUser = auth.currentUser;
    const currentUserId = currentUser ? currentUser.uid : null;
    const colRef = collection(firebase, COLLECTIONS.SUPPORT);
    const docRef = doc(colRef, id);

    await setDoc(docRef, { status: status , statusUpdateBy: currentUserId}, { merge: true });

    onSuccess && onSuccess({ status: true });
  } catch (error) {
    console.error("Error updating read status:", error);
    onError && onError({ status: false, message: error.message });
  }
}

export async function closeSupportTicket(id, onSuccess, onError) {
  try {
    const currentUser = auth.currentUser;
    const currentUserId = currentUser ? currentUser.uid : null;
    const colRef = collection(firebase, COLLECTIONS.SUPPORT);
    const docRef = doc(colRef, id);

    await setDoc(docRef, { status: "close" , closeBy: currentUserId, updatedAt: Timestamp.now()}, { merge: true });

    onSuccess && onSuccess({ status: true });
  } catch (error) {
    console.error("Error updating read status:", error);
    onError && onError({ status: false, message: error.message });
  }
}

export async function archiveSupportTicket(id, onSuccess, onError) {
  try {
    const currentUser = auth.currentUser;
    const currentUserId = currentUser ? currentUser.uid : null;
    const colRef = collection(firebase, COLLECTIONS.SUPPORT);
    const docRef = doc(colRef, id);

    await setDoc(docRef, { status: "close", archive: true , archiveAt: Timestamp.now(), archiveBy: currentUserId, updatedAt: Timestamp.now()}, { merge: true });

    onSuccess && onSuccess({ status: true });
  } catch (error) {
    console.error("Error updating read status:", error);
    onError && onError({ status: false, message: error.message });
  }
}

export async function unArchiveSupportTicket(id, onSuccess, onError) {
  try {
    const currentUser = auth.currentUser;
    const currentUserId = currentUser ? currentUser.uid : null;
    const colRef = collection(firebase, COLLECTIONS.SUPPORT);
    const docRef = doc(colRef, id);

    await setDoc(docRef, { status: "open", archive: false , unArchiveBy: currentUserId, updatedAt: Timestamp.now()}, { merge: true });

    onSuccess && onSuccess({ status: true });
  } catch (error) {
    console.error("Error updating read status:", error);
    onError && onError({ status: false, message: error.message });
  }
}

// export async function getSupportListCount(formData, onSuccess, onError) {
//   const colRef = collection(firebase, COLLECTIONS.SUPPORT);;
//   const statuses = formData?.status || [];
//   const companyId = formData?.companyId || null;

//   if (statuses.length === 0) {
//     onSuccess?.([{}]);
//     return;
//   }

//   const chunkSize = 10;
//   const chunks = [];

//   for (let i = 0; i < statuses.length; i += chunkSize) {
//     chunks.push(statuses.slice(i, i + chunkSize));
//   }

//   try {
//     const queries = chunks.map((chunk) => {
//       const filters = [where("status", "in", chunk)];
//       if (companyId) filters.push(where("companyId", "==", companyId));
//       return getDocs(query(colRef, ...filters));
//     });

//     const snapshots = await Promise.all(queries);

//     const statusCount = {};

//     snapshots.flatMap(snapshot => snapshot.docs).forEach((doc) => {
//       const status = doc.data()?.status;
//       if (status) {
//         statusCount[status] = (statusCount[status] || 0) + 1;
//       }
//     });

//     statuses.forEach((status) => {
//       if (!statusCount[status]) {
//         statusCount[status] = 0;
//       }
//     });

//     onSuccess?.([statusCount]);
//   } catch (error) {
//     console.error("Error getting support count:", error);
//     onError?.(error);
//   }
// }

export function getSupportListCount(formData, onSuccess, onError) {
  const colRef = collection(firebase, COLLECTIONS.SUPPORT);
  const companyId = formData?.companyId || null;
  const userId = formData?.userId || null;

  try {
    const filters = [];
    if (companyId) {
      filters.push(where("companyId", "==", companyId));
    }

    const q = filters.length > 0 ? query(colRef, ...filters) : colRef;

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        let unreadCount = 0;

        snapshot.forEach((doc) => {
          const data = doc.data();
          const readUser = data?.readUser;

          if (!Array.isArray(readUser) || !readUser.includes(userId)) {
            unreadCount += 1;
          }
        });

        onSuccess?.([{ unread: unreadCount }]);
      },
      (error) => {
        console.error("subscribeSupportListCount error:", error);
        onError?.(error);
      }
    );

    return unsubscribe;
  } catch (error) {
    console.error("subscribeSupportListCount setup error:", error);
    onError?.(error);
    return () => {};
  }
}

// const dateOptions = [
//   { value: "today", label: "Today" },
//   { value: "yesterday", label: "Yesterday" },
//   { value: "last7days", label: "Last 7 Days" },
//   { value: "last30days", label: "Last 30 Days" },
//   { value: "last90days", label: "Last 90 Days" },
// ];

// const getDateRange = (range) => {
//   const now = moment();
//   let start, end = now;

//   switch (range) {
//     case "today":
//       start = now.clone().startOf("day");
//       break;
//     case "yesterday":
//       start = now.clone().subtract(1, "day").startOf("day");
//       end = now.clone().subtract(1, "day").endOf("day");
//       break;
//     case "last7days":
//       start = now.clone().subtract(6, "days").startOf("day");
//       break;
//     case "last30days":
//       start = now.clone().subtract(29, "days").startOf("day");
//       break;
//     case "last90days":
//       start = now.clone().subtract(89, "days").startOf("day");
//       break;
//     default:
//       throw new Error("Invalid range");
//   }

//   return { start: start.unix(), end: end.unix() };
// };

// const fetchAllStripeData = async (type, params) => {
//   let data = [], hasMore = true, startingAfter = null;
//   while (hasMore) {
//     const res = await stripe[type].list({
//       ...params,
//       limit: 100,
//       ...(startingAfter && { starting_after: startingAfter }),
//     });
//     data = data.concat(res.data);
//     hasMore = res.has_more;
//     startingAfter = res.data[res.data.length - 1]?.id;
//   }
//   return data;
// };

// export async function getStripeRevenueAnalytics(onSuccess, onError) {
//   try {
//     const createdAfter = moment().subtract(90, "days").startOf("day").unix();

//     const [subscriptions, charges] = await Promise.all([
//       fetchAllStripeData("subscriptions", { created: { gte: createdAfter } }),
//       fetchAllStripeData("charges", { created: { gte: createdAfter } }),
//     ]);

//     const results = dateOptions.map((opt) => {
//       const { start, end } = getDateRange(opt.value);

//       const newPlans = subscriptions?.filter(
//         (s) => s.status === "active" && s.created >= start && s.created <= end
//       );

//       const renewedPlans = subscriptions?.filter(
//         (s) =>
//           s.status === "active" &&
//           s.current_period_start >= start &&
//           s.current_period_start <= end &&
//           s.created < start
//       );

//       const canceledPlans = subscriptions?.filter(
//         (s) => s.canceled_at && s.canceled_at >= start && s.canceled_at <= end
//       );

//       const filteredCharges = charges?.filter(
//         (c) =>
//           c.paid &&
//           c.status === "succeeded" &&
//           c.created >= start &&
//           c.created <= end
//       );

//       const totalRevenue = filteredCharges?.reduce((sum, c) => sum + c.amount, 0);

//       return {
//         label: opt.label,
//         range: opt.value,
//         newPlans: newPlans.length,
//         renewedPlans: renewedPlans.length,
//         canceledPlans: canceledPlans.length,
//         totalRevenue: (totalRevenue / 100).toFixed(2),
//       };
//     });

//     onSuccess?.(results);
//   } catch (error) {
//     console.error("Stripe Analytics Error:", error);
//     onError?.({ status: false, message: error.message });
//   }
// }

// const fetchAllStripeData = async (type, params) => {
//   let data = [], hasMore = true, startingAfter = null;
//   while (hasMore) {
//     const res = await stripe[type].list({
//       ...params,
//       limit: 100,
//       ...(startingAfter && { starting_after: startingAfter }),
//     });
//     data = data.concat(res.data);
//     hasMore = res.has_more;
//     startingAfter = res.data[res.data.length - 1]?.id;
//   }
//   return data;
// };

export async function getStripeRawData(onSuccess, onError) {
  try {
    const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };

    const res = await axiosInstance.post(
      `${BaseUrl}getStripeAnalytics`,
      {},
      { headers: { ...authHeaders } }
    );

    const { subscriptions, invoices, charges } = res?.data;

    onSuccess?.({ subscriptions, invoices, charges });
  } catch (error) {
    console.error("Stripe Raw Data Error:", error);
    onError?.({ status: false, message: error.message });
  }
}

function getStartTimestamp(range) {
  const now = new Date(); 

  const todayStart = new Date(now);
  todayStart.setHours(0, 0, 0, 0);

  const yesterdayStart = new Date(todayStart);
  yesterdayStart.setDate(todayStart.getDate() - 1);

  const durations = {
    '7days': 7 * 24 * 60 * 60,
    '30days': 30 * 24 * 60 * 60,
    '90days': 90 * 24 * 60 * 60,
    '1year': 365 * 24 * 60 * 60,
    'today': Math.floor(todayStart.getTime() / 1000),
    'yesterday': Math.floor(yesterdayStart.getTime() / 1000),
  };

  if (range === 'today' || range === 'yesterday') {
    return durations[range];
  }

  const nowInSeconds = Math.floor(now.getTime() / 1000);
  const offset = durations[range] || durations['30days'];
  return nowInSeconds - offset;
}


async function getTotalRevenue(range = '30days', monthly = false) {
  const startTime = getStartTimestamp(range);
  let totalRevenue = 0;
  let hasMore = true;
  let startingAfter = null;
  const monthlyRevenue = {};

  while (hasMore) {
    const params = {
      limit: 100,
      created: { gte: startTime },
    };
    if (startingAfter) {
      params.starting_after = startingAfter;
    }

    const charges = await stripe.charges.list(params);

    for (const charge of charges.data) {
      if (charge.paid && !charge.refunded) {
         if (monthly) {
          const date = new Date(charge.created * 1000);
          const month = date.toLocaleString('default', { month: 'short' });
          monthlyRevenue[month] = (monthlyRevenue[month] || 0) + charge.amount;
        } else {
          totalRevenue += charge.amount;
        }
      }
    }

    hasMore = charges.has_more;
    if (hasMore) {
      startingAfter = charges.data[charges.data.length - 1].id;
    }
  }

   if (monthly) {
    const allMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const fullMonthlyData = allMonths.map(month => ({
      month,
      revenue: parseFloat(((monthlyRevenue[month] || 0) / 100).toFixed(2)),
    }));

    return fullMonthlyData;
  }
  const revenueInDollars = (totalRevenue / 100).toFixed(2);
  return revenueInDollars;
}

export async function getRevenue(range, monthly = false) {
  const data = getTotalRevenue(range, monthly);
  return data
}

export async function getRecentSubscriptionActivities(limit = 6, range = 'today') {
  const startTimestamp = getStartTimestamp(range);
  const activities = [];

  let hasMore = true;
  let startingAfter = null;

  while (hasMore && activities.length < limit * 2) {
    const params = {
      limit: 100,
      expand: ['data.customer'],
    };
    if (startingAfter) {
      params.starting_after = startingAfter;
    }

    const subs = await stripe.subscriptions.list(params);

    for (const sub of subs.data) {
      const customer = sub.customer;
      const companyName =
        customer?.name || customer?.email || 'Unknown';

      if (sub.canceled_at && sub.canceled_at >= startTimestamp) {
        activities.push({
          time: new Date(sub.canceled_at * 1000),
          company: companyName,
          amount: (sub.plan?.amount || 0) / 100,
          type: 'Cancelled',
        });
      }

      if (sub.created >= startTimestamp) {
        activities.push({
          time: new Date(sub.created * 1000),
          company: companyName,
          amount: (sub.plan?.amount || 0) / 100,
          type: 'New Subscription',
        });
      }

      if (
        sub.current_period_start >= startTimestamp &&
        !sub.canceled_at
      ) {
        activities.push({
          time: new Date(sub.current_period_start * 1000),
          company: companyName,
          amount: (sub.plan?.amount || 0) / 100,
          type: 'Renewed',
        });
      }

      if (activities.length >= limit) break;
    }

    hasMore = subs.has_more;
    if (hasMore) {
      startingAfter = subs.data[subs.data.length - 1].id;
    }
  }

  return activities
    .sort((a, b) => b.time - a.time)
    .slice(0, limit);
}

export async function getSubscriptionsByType(range = 'today', type = 'new') {
  const startTimestamp = getStartTimestamp(range);
  let allSubs = [];
  let hasMore = true;
  let startingAfter = null;

  while (hasMore) {
    const params = {
      limit: 100,
    };
    if (startingAfter) {
      params.starting_after = startingAfter;
    }

    const subs = await stripe.subscriptions.list(params);

    for (const sub of subs.data) {
      if (type === 'new' && sub.created >= startTimestamp) {
        allSubs.push(sub);
      } else if (
        type === 'cancel' &&
        sub.canceled_at &&
        sub.canceled_at >= startTimestamp
      ) {
        allSubs.push(sub);
      } else if (
        type === 'renew' &&
        sub.current_period_start >= startTimestamp
      ) {
        allSubs.push(sub);
      }
    }

    hasMore = subs.has_more;
    if (hasMore) {
      startingAfter = subs.data[subs.data.length - 1].id;
    }
  }

  return allSubs;
} 

export async function getRecentTransactions(limit = 6, range = "30days") {
  const startTimestamp = getStartTimestamp(range);

  const invoices = await stripe.invoices.list({
    limit: 100,
    created: { gte: startTimestamp },
    expand: ["data.charge", "data.subscription", "data.customer"],
  });

  const transactions = [];

  for (const invoice of invoices.data) {
    const amount = (invoice.total || invoice.amount_paid || 0) / 100;
    const date = new Date(invoice.created * 1000);

    const chargeStatus = invoice.status || invoice.charge?.status || "pending";
    const status = chargeStatus === "succeeded" || "paid" ? "Completed" : "Pending";

    const transactionId = invoice.charge?.id || "N/A";
    const customerName = invoice.customer?.name || invoice.customer?.email || "Unknown";

    let activity = "Subscription";

    if (invoice.billing_reason === "subscription_update") {
      activity = "Plan Changed";
    } else if (invoice.billing_reason === "subscription_create") {
      activity = "New Subscription";
    } else if (invoice.billing_reason === "subscription_cycle") {
      activity = "Renewed";
    }

    if (invoice.subscription?.canceled_at && invoice.subscription?.canceled_at >= startTimestamp) {
      activity = "Plan Cancelled";
    }

    transactions.push({
      amount,
      date,
      transactionId,
      company: customerName,
      type: activity,
      status,
    });

    if (transactions.length >= limit) break;
  }

  return transactions.sort((a, b) => b.date - a.date).slice(0, limit);
}


function getStartDate(range) {
  const now = new Date();
  let start;

  switch (range) {
    case "today":
      start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      break;
    case "yesterday":
      start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
      now.setDate(now.getDate() - 1);
      break;
    case "7days":
      start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      break;
    case "30days":
      start = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      break;
    case "90days":
      start = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
      break;
    case "1year":
      start = new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000);
      break;
    default:
      start = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
  }

  return { start, end: now };
}

function parseCreatedAt(createdAt) {
  if (!createdAt) return null;
  if (createdAt?.seconds) return createdAt.toDate(); // Firestore Timestamp
  if (typeof createdAt === "number") return new Date(createdAt);
  if (typeof createdAt === "string") return new Date(createdAt);
  return null;
}

export async function getDetailsByRange(range, collectionName) {
  try {
    const { start, end } = getStartDate(range);
    const colRef = collection(firebase, collectionName);

    const q =
      range === "yesterday"
        ? query(
            colRef,
            where("createdAt", ">=", Timestamp.fromDate(start)),
            where("createdAt", "<", Timestamp.fromDate(end))
          )
        : query(
            colRef,
            where("createdAt", ">=", Timestamp.fromDate(start))
          );

    const snapshot = await getDocs(q);
    return snapshot.size || 0;
  } catch (err) {
    console.error("Error fetching details for", collectionName, err);
    return 0;
  }
}

const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function getDateRange(range) {
  const end = new Date();
  const start = new Date();

  if (range === "7days") start.setDate(end.getDate() - 6);
  else if (range === "30days") start.setDate(end.getDate() - 29);
  else if (range === "90days") start.setDate(end.getDate() - 89);
  else if (range === "1year") start.setFullYear(end.getFullYear() - 1);

  start.setHours(0, 0, 0, 0);
  end.setHours(23, 59, 59, 999);

  return { start, end };
}

function initializeWeekdayMap() {
  return weekdays.reduce((acc, day) => {
    acc[day] = { day, logins: 0, tickets: 0 };
    return acc;
  }, {});
}

export async function getWeeklyAggregatedActivity(range = "7days") {
  const { start, end } = getDateRange(range);
  const map = initializeWeekdayMap();

  // Fetch logins
  const loginQuery = query(
    collection(firebase, COLLECTIONS.HISTORY),
    where("login", "==", true),
    where("createdAt", ">=", Timestamp.fromDate(start)),
    where("createdAt", "<=", Timestamp.fromDate(end))
  );
  const loginSnap = await getDocs(loginQuery);
  loginSnap.forEach(doc => {
    const ts = doc.data().createdAt?.toDate();
    if (ts) {
      const day = weekdays[ts.getDay()];
      map[day].logins += 1;
    }
  });

  // Fetch tickets
  const ticketQuery = query(
    collection(firebase, COLLECTIONS.SUPPORT),
    where("createdAt", ">=", Timestamp.fromDate(start)),
    where("createdAt", "<=", Timestamp.fromDate(end))
  );
  const ticketSnap = await getDocs(ticketQuery);
  ticketSnap.forEach(doc => {
    const ts = doc.data().createdAt?.toDate();
    if (ts) {
      const day = weekdays[ts.getDay()];
      map[day].tickets += 1;
    }
  });

  return weekdays.map(day => map[day]); // keep order: Sun -> Sat
}

export async function getUsersRange(range, filter = "all", allData = false, subscription = false) {
  try {
    const { start } = getStartDate(range);
    const colRef = collection(firebase, COLLECTIONS.USERS);
    const snapshot = await getDocs(colRef);

    let count = 0;
    const monthCounts = {};
    const subscriptionUsers = [];

    for (const doc of snapshot.docs) {
      const user = doc.data();

      const createdDate = parseCreatedAt(user.createdAt);
      if (!createdDate || isNaN(createdDate)) continue;

      if (user?.role?.toLowerCase() === "superuser") continue;

      if (subscription) {
        subscriptionUsers.push(user);
        continue;
      }

      if (allData) {
        const month = createdDate.toLocaleString("default", { month: "short" });
        monthCounts[month] = (monthCounts[month] || 0) + 1;
        continue;
      }

      if (filter === "active" && (user.status === false || user.deleted === true)) {
        continue;
      }

      if (range === "yesterday") {
        const end = new Date(start.getTime() + 24 * 60 * 60 * 1000);
        if (createdDate >= start && createdDate < end) count++;
      } else {
        if (createdDate >= start) count++;
      }
    }

    if (subscription) return subscriptionUsers;
    return allData ? monthCounts : count;

  } catch (err) {
    console.error("Error fetching users:", err);
    return subscription ? [] : allData ? {} : 0;
  }
}

export async function getUsersData(range, companyUsers = null, cancel = false) {
  try {
    const { start } = getStartDate(range);
    const colRef = collection(firebase, COLLECTIONS.USERS);
    const snapshot = await getDocs(colRef);

    let count = 0;

    for (const doc of snapshot.docs) {
      const user = doc.data();

      if (user?.role?.toLowerCase() === "superuser") continue;

      if (companyUsers === true && user?.role !== "companyUser") continue;
      if (companyUsers === false && user?.role === "companyUser") continue;

      if (cancel) {
        const isCanceled =
          user.status === false ||
          user.status === "canceled" ||
          user.deletedAt !== undefined ||
          user.cancelAt !== undefined;

        if (!isCanceled) continue;

        const cancelDate = user.cancelAt || user.deletedAt;
        const cancelTimestamp = parseCreatedAt(cancelDate);
        if (!cancelTimestamp || isNaN(cancelTimestamp)) continue;

        if (range === "yesterday") {
          const end = new Date(start.getTime() + 24 * 60 * 60 * 1000);
          if (cancelTimestamp >= start && cancelTimestamp < end) count++;
        } else {
          if (cancelTimestamp >= start) count++;
        }

      } else {
        const createdDate = parseCreatedAt(user.createdAt);
        if (!createdDate || isNaN(createdDate)) continue;

        if (range === "yesterday") {
          const end = new Date(start.getTime() + 24 * 60 * 60 * 1000);
          if (createdDate >= start && createdDate < end) count++;
        } else {
          if (createdDate >= start) count++;
        }
      }
    }

    return count;
  } catch (err) {
    console.error("Error fetching users:", err);
    return 0;
  }
}

